import request from '@/utils/request'

// 用户服务信息
export function getServiceInfo(params) {
  return request({
    url: '/ai/user/getServiceInfo',
    method: 'get',
    params
  })
}
